import { useEffect, useRef } from 'react';
import { useAuthStore } from '@/stores/authStore';

export const useAuthInit = () => {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const state = useAuthStore.getState();
    const hasAccessToken = !!state.accessToken;
    const hasUser = !!state.user;

    // Sync isAuthenticated state after rehydration
    if (hasAccessToken && hasUser && !state.isAuthenticated) {
      useAuthStore.setState({ isAuthenticated: true });
    }
  }, []);
};
